import { render, staticRenderFns } from "./MemberActivation.vue?vue&type=template&id=6608c610&scoped=true&"
import script from "./MemberActivation.vue?vue&type=script&lang=js&"
export * from "./MemberActivation.vue?vue&type=script&lang=js&"
import style0 from "./MemberActivation.vue?vue&type=style&index=0&id=6608c610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608c610",
  null
  
)

export default component.exports